import { Helmet } from "react-helmet";
import CaseStudiesLayout from "../sections/caseStudies/caseStudiesLayout";

const CaseStudiesPage = () => {
    return (
        <>
            <Helmet>
                <title>Success Stories | code3x Case Studies in AI, Games & Digital Projects</title>
                <meta name="description" content="Discover how code3x has delivered impactful AI, games, and digital solutions for clients worldwide." />
                <meta name="keywords" content="code3x case studies, AI projects, gaming success stories, digital solutions examples, client projects, code3x portfolio, leading tech company, Sri Lanka" />
                <link rel="canonical" href="https://code3x.tech/case-studies" />
            </Helmet>

            <CaseStudiesLayout />
        </>
    );
}

export default CaseStudiesPage;